import { useMutation, useQueryClient } from "@tanstack/react-query";

import { logout } from "@/app/api/legacy-api";
import { useMessenger } from "@/app/hooks/use-messenger";
import { useModalsDisplayStore, usePortalUserStore } from "@/app/stores";
import { triggerCustomerIoUserLoggedOut } from "@/features/analytics/triggers";
import {
  sendMessageToReactNativeWebView,
  WEB_VIEW_ACTIONS,
} from "@/shared/lib";
import { authStore } from "@/shared/stores";

export const useLogout = () => {
  const queryClient = useQueryClient();
  const markTestosteroneLabsNotificationAsSeen = useModalsDisplayStore(
    (state) => state.markTestosteroneLabsNotificationAsSeen,
  );
  const user = usePortalUserStore((state) => state.portalUser);

  const {
    actions: { hideMessenger },
  } = useMessenger();

  return useMutation({
    mutationFn: logout,
    onSuccess: () => {
      sendMessageToReactNativeWebView({ type: WEB_VIEW_ACTIONS.LOGOUT });
      authStore.setToken(null);
      queryClient.removeQueries();
      hideMessenger();
      markTestosteroneLabsNotificationAsSeen(false);
      if (user) {
        triggerCustomerIoUserLoggedOut({ userEmail: user.email });
      }
    },
  });
};
